// Salary is off for everyone, the system Admin included (backend/lib/rbac.js isPayLocked). The server
// leaves these two out of the permission list it sends, so here they are granted only when that list
// names them: no admin pass, no role fallback.
// The bonus keys and the MoM Bonus keys are pay as well on live (backend/lib/rbac.js PAY_PERMISSION_KEYS).
export const MOM_BONUS_KEYS = [
  'dossier.view_mom_bonus_own',
  'dossier.view_mom_bonus_below', 'dossier.edit_mom_bonus_below',
  'dossier.view_mom_bonus_all', 'dossier.edit_mom_bonus_all'
];
const PAY_KEYS = new Set([
  'dossier.view_salary', 'dossier.edit_salary',
  'dossier.view_bonuses', 'dossier.edit_bonuses',
  ...MOM_BONUS_KEYS
]);

export const hasPermission = (user, permissionKey) => {
  if (!user || !permissionKey) return false;
  if (PAY_KEYS.has(permissionKey)) {
    return Array.isArray(user.permissions) && user.permissions.includes(permissionKey);
  }
  // Admins always pass. This must run before the explicit-permissions check so an admin that happens
  // to arrive with an empty (or partial) permissions array isn't locked out of gated screens.
  if (user.role === 'admin') return true;
  // Only treat an explicit permissions array as authoritative when it actually lists grants. An empty
  // array must fall through to the role-based defaults rather than silently revoking all access.
  if (Array.isArray(user.permissions) && user.permissions.length > 0) {
    return user.permissions.includes(permissionKey);
  }
  if (permissionKey === 'phm.access' || permissionKey === 'phm.view_reports') return user.role === 'manager' || user.role === 'admin';
  // The External tools box (2026-11-05) is on for every position that existed then; for a session with no permission list the server still decides what is sent.
  if (permissionKey === 'home.external_tools') return true;
  if (permissionKey === 'phm.off_shift') return user.role === 'admin';
  if (permissionKey === 'phm.interval_edit') return user.role === 'admin';
  if (permissionKey === 'breaks.all_breaks' || permissionKey === 'breaks.historic') {
    return user.role === 'manager' || user.role === 'admin' || user.role === 'viewer';
  }
  return user.role === 'admin';
};

/** Does the user hold any of the five MoM Bonus keys? The server then decides, profile by profile, whether the Bonus group shows. */
export const canSeeMomBonus = (user) => MOM_BONUS_KEYS.some((key) => hasPermission(user, key));
